'use client'

import { useEffect, useRef, useState } from 'react'

import { useRouter } from 'next/navigation'

import Typography from '@mui/material/Typography'

import classnames from 'classnames'
import { signIn, useSession } from 'next-auth/react'

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo'

import dayjs from 'dayjs'

import axios from 'axios'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import TimelineDot from '@mui/lab/TimelineDot'

import BusinessIcon from '@mui/icons-material/Business'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import Timeline from '@mui/lab/Timeline'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent'
import TimelineSeparator from '@mui/lab/TimelineSeparator'

import Dialog from '@mui/material/Dialog'

import DialogContent from '@mui/material/DialogContent'

import Box from '@mui/material/Box'

import IconButton from '@mui/material/IconButton'

import Divider from '@mui/material/Divider'

import TextField from '@mui/material/TextField'

import Autocomplete from '@mui/material/Autocomplete'

import InputAdornment from '@mui/material/InputAdornment'

import DialogActions from '@mui/material/DialogActions'

import Grid from '@mui/material/Grid'

import FingerprintJS from '@fingerprintjs/fingerprintjs'

import NumericFormatCustom from '@/components/NumericFormatCustom'
import ConfirmationDialog from '@/components/layout/shared/ConfirmationDialog'
import CustomButton from '@/components/layout/shared/CustomButton'
import LogoLogin from '@/components/layout/shared/LogoLogin'
import getUrlApiLogin, { encryptAES } from '@/utils/getUrlApiLogin'
import showToastAlert from '@components/Toast'
import themeConfig from '@configs/themeConfig'
import { useSettings } from '@core/hooks/useSettings'

const dataShift = [
  { value: 0, label: 'Pagi' },
  { value: 1, label: 'Siang' },
  { value: 2, label: 'Malam' }
]

interface DataUnit {
  ID_UNIT: string
  NAMA_UNIT: string
  ALAMAT: string
  KOTA: string
  LABA: string
  NONRACIK: string
  RACIK: string
  DT: string
  BPJS_LABA: string
  BPJS_NONRACIK: string
  BPJS_RACIK: string
  BPJS_DT: string
  ID_AKUN: string
  ID_KAS: string
  ID_JUAL: string
  ID_USAHA: string
  NAMA_USAHA: string
  ALAMAT_USAHA: string
  KOTA_USAHA: string
  NPWP: string
  URLPUSAT: string
  URLUTAMA: string
  URLPUSAT_DOMAIN: string
  URLUTAMA_DOMAIN: string
}

const Login = () => {
  const { settings } = useSettings()

  const router = useRouter()
  const { data: session, status } = useSession()

  const [isPasswordShown, setIsPasswordShown] = useState(false)
  const [loading, setLoading] = useState(false)

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [open, setOpen] = useState(false)
  const [tglTransOrder, setTglTransOrder] = useState<dayjs.Dayjs | null>(dayjs())
  const [selectedShift, setselectedShift] = useState('')
  const [saldo, setSaldo] = useState('')
  const [pegawai, setPegawai] = useState('')
  const [idUnit, setIdUnit] = useState('')
  const [idPegawai, setIdPegawai] = useState('')
  const [loadingSimpan, setLoadingSimpan] = useState<boolean>(false)
  const [selectedUnit, setUnitSelected] = useState('')
  const [rowSelectedUnit, setRowSelectedUnit] = useState<DataUnit | null>(null)
  const [openUnit, setOpenUnit] = useState(false)
  const [unitList, setDataUnit] = useState<DataUnit[]>([])

  const handleClickShowPassword = () => setIsPasswordShown(show => !show)
  const unitRef = useRef<HTMLInputElement | null>(null)
  const [latitude, setLatitude] = useState<number | null>(null)
  const [longitude, setLongitude] = useState<number | null>(null)
  const [locationError, setLocationError] = useState<string | null>(null)
  const [idUnitLast, setIdUnitLast] = useState('')
  const [dialogConfirm, setDialogConfirm] = useState(false)

  const [fingerprintId, setFingerprintId] = useState<string>('')
  const [openFingerprintDialog, setOpenFingerprintDialog] = useState(false)

  useEffect(() => {
    // Initialize an agent
    const fpPromise = FingerprintJS.load()

    fpPromise
      .then(fp => fp.get())
      .then(result => {
        setFingerprintId(result.visitorId)
      })

    getLocation()
  }, [])

  const getLocation = () => {
    if (!navigator.geolocation) {
      setLocationError('Geolocation tidak didukung browser ini.')

      return
    }

    // Opsi konfigurasi untuk akurasi tinggi
    const options = {
      enableHighAccuracy: true, // Memaksa browser menggunakan GPS (jika tersedia)
      timeout: 10000, // Waktu tunggu maksimal (10 detik) sebelum error
      maximumAge: 0 // Jangan gunakan lokasi yang dicache, cari yang baru
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        setLatitude(position.coords.latitude)
        setLongitude(position.coords.longitude)
        setLocationError(null)
      },
      error => {
        setLocationError('Gagal mendapatkan lokasi: ' + error.message)
      },
      options // <--- Masukkan opsi di sini sebagai parameter ketiga
    )
  }

  useEffect(() => {
    if (status === 'authenticated') {
      const redirectTo = '/kasir-home'

      router.push(redirectTo)
    }
  }, [status, session, router])

  const doLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!username) {
      showToastAlert('info', 'Username tidak boleh kosong')

      return
    }

    if (!password) {
      showToastAlert('info', 'Password tidak boleh kosong')

      return
    }

    setLoading(true)
    await clearAllCookies()

    const url = await getUrlApiLogin()

    try {
      const formData = {
        user: username,
        pass: password
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(url + 'login/loginadmin', {
        data: encryptedData
      })

      if (response.data.metadata.code === 200) {
        const session = response.data.response.list[0]

        if (session) {
          const idJabatan = session?.ID_JABATAN
          const idPegawai = session?.ID_PEGAWAI

          if (idJabatan === '3' || idJabatan === 3) {
            setPegawai(session?.NAMA_PEGAWAI)
            setIdPegawai(session?.ID_PEGAWAI)
            setIdUnit(selectedUnit)

            getDataUnit(idPegawai)
          } else {
            showToastAlert('info', 'Anda tidak memiliki hak akses')
          }
        } else {
          showToastAlert('info', 'Anda tidak memiliki hak akses')
        }
      } else {
        showToastAlert('info', response.data.metadata.message)
      }
    } catch (error) {
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoading(false)
    }
  }

  const getDataUnit = async (idPegawai: string) => {
    const url = await getUrlApiLogin()

    try {
      const formData = {
        idpegawai: idPegawai
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(url + 'login/loginunit', {
        data: encryptedData
      })

      if (response.data.metadata.code === 200) {
        const data = response.data.response.list

        setDataUnit(data)

        setUnitSelected(data[0]?.ID_UNIT || '')
        setIdUnitLast('')
        setRowSelectedUnit(data[0] || null)

        const lastUnitResponse = await axios.post(url + 'login/loginterahir', {
          data: encryptedData
        })

        if (lastUnitResponse.data?.metadata?.code === 200 && lastUnitResponse.data.response.list?.length > 0) {
          const lastUnitId = lastUnitResponse.data.response.list[0].ID_UNIT
          const foundUnit = data.find((unit: DataUnit) => unit.ID_UNIT === lastUnitId)

          if (foundUnit) {
            setUnitSelected(foundUnit.ID_UNIT)
            setIdUnitLast(foundUnit.ID_UNIT)
            setRowSelectedUnit(foundUnit)
          } else {
            setUnitSelected(data[0]?.ID_UNIT || '')
            setIdUnitLast('')
            setRowSelectedUnit(data[0] || null)
          }
        } else {
          setUnitSelected(data[0]?.ID_UNIT || '')
          setIdUnitLast('')
          setRowSelectedUnit(data[0] || null)
        }

        setTimeout(() => {
          unitRef.current?.focus()
        }, 100)
        setOpenUnit(true)
      } else {
        showToastAlert('info', response.data.metadata.message)
      }
    } catch (error) {
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    }
  }

  const clearAllCookies = async () => {
    // Hapus client-side cookies
    const cookies = document.cookie.split('; ')

    cookies.forEach(cookie => {
      const [name] = cookie.split('=')

      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`
    })

    console.log('Client-side cookies cleared!')

    // Hapus server-side cookies
    try {
      await axios.get('/api/clear-cookies')
      console.log('Server-side cookies cleared!')
    } catch (error) {
      console.error('Failed to clear server-side cookies:', error)
    }
  }

  const doLoginSession = async (noreg: string = '', url: string = '') => {
    if (selectedUnit === '') {
      showToastAlert('info', 'Silakan pilih unit usaha terlebih dahulu')

      return
    }

    if (!rowSelectedUnit) {
      showToastAlert('info', 'Data unit usaha tidak valid')

      return
    }

    if (username === '' || password === '') {
      showToastAlert('info', 'Username dan Password tidak boleh kosong')

      return
    }

    setLoading(true)
    let isurlpublic = ''

    if (url === (process.env.NEXT_PUBLIC_API_URL as string)) {
      isurlpublic = 'true'
    } else {
      isurlpublic = 'false'
    }

    const formData = {
      user: username,
      pass: password,
      idunit: selectedUnit,
      deviceid: fingerprintId
    }

    const encryptedData = await encryptAES(JSON.stringify(formData))

    try {
      const result = await signIn('credentials', {
        redirect: false,
        data: encryptedData,
        noreg: noreg,
        rowSelectedUnit: JSON.stringify(rowSelectedUnit),
        isurlpublic: isurlpublic
      })

      if (result?.error) {
        showToastAlert('info', result.error)
      } else {
        try {
          const logData = {
            idunit: rowSelectedUnit?.ID_UNIT,
            idusaha: rowSelectedUnit?.ID_USAHA,
            idpegawai: idPegawai,
            status: 0, // login
            namauser: username,
            longitude: longitude || '',
            latitude: latitude || ''
          }

          const encryptedLogData = await encryptAES(JSON.stringify(logData))

          const logResponse = await axios.post(url + 'login/savelogin_logout', { data: encryptedLogData })

          if (logResponse.data?.metadata?.code !== 200) {
            showToastAlert('error', logResponse.data?.metadata?.message || 'Gagal menyimpan log login')
            setLoading(false)

            return
          } else {
            router.push(themeConfig.homePageUrl)
          }
        } catch (err) {
          showToastAlert('error', 'Gagal menyimpan log login')
          setLoading(false)

          return
        }
      }
    } catch (error) {
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoading(false)
    }
  }

  const cariRegKasir = async (idPegawai: string, idUnit: string, isOk = false) => {
    if (!isOk) {
      if (idUnitLast != '') {
        if (idUnitLast !== selectedUnit) {
          setDialogConfirm(true)

          return
        }
      }
    }

    const url = await getUrlApiLogin()

    setLoading(true)

    try {
      const formData = {
        idpegawai: idPegawai,
        idunit: idUnit
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(url + 'kasir/cariregkasir', {
        data: encryptedData
      })

      if (response.data.metadata.code === 200) {
        const data = response.data.response.list[0]

        doLoginSession(data?.NOMOR, url as string)
      } else {
        setOpen(true)
        setSaldo('0')
        showToastAlert('info', response.data.metadata.message)
      }
    } catch (error) {
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    localStorage.removeItem('sessionExpiry')
    setOpen(false)
  }

  const handleShiftChange = (event: any, value: any) => {
    if (value) {
      setselectedShift(value.value)
    } else {
      setselectedShift('')
    }
  }

  const saveRegistrasi = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    setLoadingSimpan(true)
    const urlH = await getUrlApiLogin()

    try {
      const url = `${urlH}kasir/saveregkasir`

      const formData = {
        nomor: null,
        idunit: selectedUnit,
        tgl: tglTransOrder ? tglTransOrder.format('YYYY-MM-DD HH:mm') : dayjs().format('YYYY-MM-DD HH:mm'),
        idpegawai: idPegawai,
        shift: selectedShift || 0,
        saldo: saldo || '0',
        idaktif: '0'
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(url, {
        data: encryptedData
      })

      if (response.data.metadata.code === 200) {
        setOpen(false)
        const data = response.data.response.list[0]

        doLoginSession(data?.NOMOR, urlH as string)
      } else {
        showToastAlert('info', response.data.metadata.message)
      }
    } catch (error) {
      console.error('Error:', error)
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoadingSimpan(false)
    }
  }

  const handleChangeUnit = (value: any) => {
    if (value) {
      setUnitSelected(value.ID_UNIT)
      setRowSelectedUnit(value)
    } else {
      setUnitSelected('')
      setRowSelectedUnit(null)
    }
  }

  const handleCloseUnit = () => {
    setOpenUnit(false)
    setDataUnit([])
  }

  const handleDialogCloseConfirm = (confirmed: boolean) => {
    setDialogConfirm(false)

    if (confirmed) {
      cariRegKasir(idPegawai, selectedUnit, true)
    }
  }

  return (
    <>
      <ConfirmationDialog
        open={dialogConfirm}
        onClose={handleDialogCloseConfirm}
        title='Konfirmasi Perubahan Unit'
        content={
          <Box sx={{ px: 1 }}>
            <Typography variant='body1' sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
              Anda akan login ke unit yang berbeda dari login terakhir
            </Typography>

            <Timeline position='alternate' sx={{ my: 2 }}>
              <TimelineItem>
                <TimelineOppositeContent sx={{ m: 'auto 0' }} variant='body2' color='text.secondary'>
                  Unit Terakhir
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot color='warning' variant='outlined'>
                    <BusinessIcon fontSize='small' />
                  </TimelineDot>
                  <TimelineConnector sx={{ bgcolor: 'primary.main' }} />
                </TimelineSeparator>
                <TimelineContent sx={{ py: '12px', px: 2 }}>
                  <Typography variant='h6' component='span' sx={{ fontWeight: 600 }}>
                    {unitList.find(unit => unit.ID_UNIT === idUnitLast)?.NAMA_UNIT || 'Tidak diketahui'}
                  </Typography>
                </TimelineContent>
              </TimelineItem>

              <TimelineItem>
                <TimelineOppositeContent sx={{ m: 'auto 0' }} variant='body2' color='text.secondary'>
                  Unit Terpilih
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot color='primary'>
                    <SwapHorizIcon fontSize='small' />
                  </TimelineDot>
                </TimelineSeparator>
                <TimelineContent sx={{ py: '12px', px: 2 }}>
                  <Typography variant='h6' component='span' sx={{ fontWeight: 600, color: 'primary.main' }}>
                    {rowSelectedUnit?.NAMA_UNIT || 'Tidak dipilih'}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            </Timeline>

            <Box
              sx={{
                bgcolor: 'grey.50',
                borderRadius: 2,
                p: 2,
                mt: 3,
                border: '1px dashed',
                borderColor: 'primary.main'
              }}
            >
              <Typography variant='body1' sx={{ textAlign: 'center', fontWeight: 500 }}>
                Lanjutkan login dengan unit yang baru dipilih?
              </Typography>
            </Box>
          </Box>
        }
      />
      <Dialog fullWidth open={open} onClose={handleClose} maxWidth='xs' scroll='body'>
        <form noValidate autoComplete='off' onSubmit={saveRegistrasi} className='flex flex-col gap-5'>
          <DialogContent className='overflow-visible pbs-0 sm:pbe-2 sm:pli-5'>
            <div className='flex justify-between items-center mb-5 mt-5'>
              <Typography variant='h5'>Registrasi Kasir</Typography>
              <IconButton onClick={handleClose} color='primary' size='small'>
                <i className='ri-close-line' />
              </IconButton>
            </div>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} mt={-1}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DateTimePicker']}>
                    <DemoItem>
                      <DateTimePicker
                        readOnly
                        label='Tanggal'
                        format='DD-MM-YYYY HH:mm'
                        ampm={false}
                        value={tglTransOrder}
                        onChange={newValue => {
                          setTglTransOrder(newValue)
                        }}
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            backgroundColor: '#f0f0f0'
                          },
                          '& .MuiIconButton-root': {
                            color: '#f0f0f0' // Samakan warna icon dengan background
                          }
                        }}
                        slotProps={{
                          textField: {
                            InputProps: {
                              inputProps: {
                                style: {
                                  textTransform: 'uppercase',
                                  backgroundColor: '#f0f0f0',
                                  opacity: 1
                                }
                              },
                              readOnly: true
                            }
                          }
                        }}
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  disabled
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#f0f0f0'
                    },
                    '& .MuiIconButton-root': {
                      color: '#f0f0f0' // Samakan warna icon dengan background
                    }
                  }}
                  InputProps={{
                    readOnly: true,
                    style: { textAlign: 'left', backgroundColor: '#f0f0f0' },
                    inputProps: {
                      style: { textAlign: 'left', textTransform: 'uppercase' }
                    }
                  }}
                  fullWidth
                  label='Pegawai'
                  onChange={e => setPegawai(e.target.value)}
                  defaultValue={pegawai}
                  placeholder='Pegawai'
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  disableClearable
                  options={dataShift}
                  getOptionLabel={option => option.label}
                  value={
                    dataShift.find(option => option.value === Number(selectedShift)) ?? {
                      label: '',
                      value: 0
                    }
                  }
                  onChange={handleShiftChange}
                  renderInput={params => <TextField {...params} label='Pilih Shift' />}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label='Saldo'
                  onChange={e => setSaldo(e.target.value)}
                  defaultValue={saldo}
                  placeholder='Saldo'
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                    inputProps: {
                      style: { textTransform: 'uppercase', textAlign: 'right', opacity: 1 }
                    }
                  }}
                  sx={{
                    '& .MuiInput-input': {
                      textAlign: 'right'
                    }
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className='justify-center pbs-0 sm:pbe-6 sm:pli-5'>
            <CustomButton type='submit' loading={loadingSimpan}>
              Simpan
            </CustomButton>
            <CustomButton variant='outlined' type='reset' onClick={handleClose} color='secondary' loading={false}>
              Keluar
            </CustomButton>
          </DialogActions>
        </form>
      </Dialog>
      <div className='flex bs-full justify-center' style={{ display: open ? 'none' : undefined }}>
        <div
          className={classnames(
            'flex bs-full items-center justify-center flex-1 min-bs-[100dvh] relative p-6 max-md:hidden',
            {
              'border-ie': settings.skin === 'bordered'
            }
          )}
        >
          <img
            src='/images/icon/logo_blue_big.jpg'
            alt=''
            className='absolute inset-0 w-full h-full object-cover z-[-1]'
          />
        </div>
        <div className='flex justify-center items-center bs-full bg-backgroundPaper !min-is-full p-6 md:!min-is-[unset] md:p-12 md:is-[480px]'>
          <div className='absolute block sm:hidden block-start-5 inline-start-6'>
            <LogoLogin />
          </div>
          <div className='flex flex-col gap-5 is-full sm:is-auto md:is-full sm:max-is-[400px] md:max-is-[unset]'>
            <div>
              <Typography variant='h5' className='text-center'>
                Selamat datang di
                <strong>{` ${themeConfig.templateName}! 👋🏻`}</strong>
              </Typography>
            </div>
            <form
              noValidate
              onSubmit={event => {
                event.preventDefault()

                if (!openUnit) {
                  doLogin(event)
                } else {
                  cariRegKasir(idPegawai, selectedUnit)
                }
              }}
              autoComplete='off'
              className='flex flex-col gap-5'
            >
              <TextField
                fullWidth
                label='Username'
                onChange={e => setUsername(e.target.value)}
                InputProps={{
                  readOnly: openUnit,
                  style: { textAlign: 'left', backgroundColor: openUnit ? '#f0f0f0' : '' },
                  inputProps: {
                    style: { textAlign: 'left', textTransform: 'uppercase' }
                  }
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: openUnit ? '#f0f0f0' : ''
                  },
                  '& .MuiInput-input': {
                    textAlign: 'left'
                  }
                }}
              />
              <TextField
                fullWidth
                label='Password'
                type={isPasswordShown ? 'text' : 'password'}
                onChange={e => setPassword(e.target.value)}
                InputProps={{
                  readOnly: openUnit,
                  style: { textAlign: 'left', backgroundColor: openUnit ? '#f0f0f0' : '' },
                  inputProps: {
                    style: { textAlign: 'left', textTransform: 'uppercase' }
                  },
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        size='small'
                        edge='end'
                        onClick={handleClickShowPassword}
                        onMouseDown={e => e.preventDefault()}
                      >
                        <i className={isPasswordShown ? 'ri-eye-off-line' : 'ri-eye-line'} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: openUnit ? '#f0f0f0' : ''
                  },
                  '& .MuiInput-input': {
                    textAlign: 'left'
                  }
                }}
              />
              {openUnit && (
                <Autocomplete
                  autoFocus
                  options={unitList}
                  getOptionLabel={(option: string | DataUnit) => {
                    if (typeof option === 'string') {
                      return option
                    } else {
                      return option.NAMA_UNIT
                    }
                  }}
                  value={
                    unitList.find((option: DataUnit) => Number(option.ID_UNIT) === Number(selectedUnit)) || undefined
                  }
                  onChange={(event, value) => {
                    handleChangeUnit(value as DataUnit)
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Unit Usaha'
                      inputRef={input => {
                        unitRef.current = input
                      }}
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true // Membuat input tidak bisa diketik manual
                      }}
                    />
                  )}
                  disableClearable
                />
              )}
              {/* Login Buttons */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  gap: 2
                }}
              >
                <CustomButton type='submit' loading={loading} color='primary'>
                  Log In
                </CustomButton>
                {openUnit && (
                  <CustomButton type='button' onClick={handleCloseUnit} loading={loading} color='secondary'>
                    Log Out
                  </CustomButton>
                )}
              </Box>
              {/* <Divider>Tidak Bisa Login?</Divider>
              <CustomButton
                loading={false}
                fullWidth={true}
                type='button'
                color='info'
                onClick={() => setOpenFingerprintDialog(true)}
                size='small'
              >
                Get Device ID
              </CustomButton> */}
            </form>
          </div>
        </div>
      </div>

      <Dialog
        open={openFingerprintDialog}
        onClose={() => setOpenFingerprintDialog(false)}
        maxWidth='xs'
        fullWidth
        transitionDuration={0}
      >
        <DialogContent className='overflow-visible pbs-0 sm:pbe-2 sm:pli-5'>
          <div className='flex justify-between items-center mb-5 mt-5'>
            <Typography variant='h5'>Fingerprint ID</Typography>
            <IconButton onClick={() => setOpenFingerprintDialog(false)} color='primary' size='small' tabIndex={-1}>
              <i className='ri-close-line' />
            </IconButton>
          </div>
          <Box sx={{ py: 2 }}>
            <Typography variant='body2' color='text.secondary' sx={{ mb: 2, textAlign: 'center' }}>
              Silakan copy code ini dan kasihkan ke pihak IT
            </Typography>
            <Typography
              variant='body1'
              sx={{
                wordBreak: 'break-all',
                fontFamily: 'monospace',
                bgcolor: 'grey.100',
                p: 2,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.300',
                mb: 2
              }}
            >
              {fingerprintId || 'Loading...'}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CustomButton
                loading={false}
                type='button'
                color='primary'
                onClick={() => {
                  if (fingerprintId) {
                    navigator.clipboard.writeText(fingerprintId)
                    showToastAlert('success', 'Fingerprint ID berhasil disalin!')
                    setOpenFingerprintDialog(false)
                  }
                }}
                size='small'
              >
                Copy
              </CustomButton>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default Login
